export default __webpack_public_path__ + "media/images/work_with_us/work_hero_md-4648994b28bb0484b2cfb4a565bbf47b.webp";